// extracted by mini-css-extract-plugin
module.exports = {"RichText":"styles_RichText__kmy0F","uppercaseLink":"styles_uppercaseLink__4J2rW","link":"styles_link__j2E75"};